import { RouteRecordRaw } from 'vue-router'

const tabs: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ './index.vue'), // 首页,
    meta: {
      title: '李留住作品展示与个人简介',
      keepAlive: true
    }
  }
]
const global: Array<RouteRecordRaw> = []

export default {
  tabs,
  global
}
